import React from "react";
import { Card, Tabs } from "antd";
import PortfolioListComponent from "../Component/PortfolioListComponet";
import AddTeamMember from "../Component/AddTeamMember";

const AddTeam = () => {
  const { TabPane } = Tabs;
  function callback(key) {
    //   console.log(key);
  }
  return (
    <div>
      <Card>
        <Tabs defaultActiveKey="1" onChange={callback} size="large" centered>
          {/* <TabPane tab="Portfolio Page  Setting" key="1">
        <MenuLogoSection/>
        </TabPane> */}

          <TabPane tab="Add Founder/Team Member" key="1">
            <AddTeamMember />
          </TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default AddTeam;
